import {useEffect} from 'react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

const SCRIPT_ID = 'usntA42start'

const AssistiveADA = () => {
    const {
        app: {commerceAPI}
    } = getConfig()

    const {usablenet} = commerceAPI
    const {config} = usablenet || {}

    let enableAssistiveADA = false
    let usablenetTagUrl = null

    try {
        const jsonConfig = JSON.parse(config)
        enableAssistiveADA = jsonConfig.enabled
        usablenetTagUrl = jsonConfig.scriptURL
    } catch (e) {
        console.log(e.message)
    }

    useEffect(() => {
        if (!enableAssistiveADA || !usablenetTagUrl) return

        // Guard against double injection (re-renders, remounts, StrictMode, route changes)
        if (document.getElementById(SCRIPT_ID)) return

        const script = document.createElement('script')
        script.id = SCRIPT_ID
        script.src = usablenetTagUrl
        script.async = true
        script.defer = true
        script.setAttribute('data-rapid', 'true')
        document.head.appendChild(script)

        // Intentionally no cleanup: removing and re-adding the script
        // would cause the third-party tag to execute again.
    }, [enableAssistiveADA, usablenetTagUrl])

    return null
}

export default AssistiveADA
